module.exports = __webpack_public_path__ + "img/6.8.TSS.dba26b46.png";